import React from 'react';
import InputAdornment from '@material-ui/core/InputAdornment';
import { SearchIcon } from '../icons';
const SearchAdornment = () => /*#__PURE__*/React.createElement(InputAdornment, {
  position: "start"
}, /*#__PURE__*/React.createElement(SearchIcon, null));
export default SearchAdornment;